import { DataService } from '../../../services/data_service';
import { filterMethodFulltext } from '../../../core/forms/helpers/filter_method_fulltext';
import { IDs } from '../../../helpers/IDs';
import { lazyInject } from '../../../services/inversify';
import parse from 'html-react-parser';
import * as React from 'react';
import { TriggerService } from '../../../core/trigger/trigger_service';
import { WFormsTableWrapper } from '../../../core/table/WFormsTableWrapper';

export interface DatenverwaltungMedienProps {
    admin?: boolean;
}

export interface DatenverwaltungMedienState {
    data: any[];
}

export class DatenverwaltungMedien extends React.Component<DatenverwaltungMedienProps, DatenverwaltungMedienState> {

    constructor(props: any) {
        super(props);
        this.state = {
            data: []
        };
    }

    @lazyInject(TriggerService) private triggerService: TriggerService;
    @lazyInject(DataService) private dataService: DataService;

    componentDidMount(): void {
        this.loadData();
    }

    loadData(): void {
        this.dataService.loadData(
            IDs.ENT_MEDIEN, {}, {},
            (res: any) => {
                if (Array.isArray(res[IDs.ENT_MEDIEN])) {
                    const data = this.processData(res[IDs.ENT_MEDIEN]);
                    this.setState({ data });
                }
            },
            IDs.MOD_ETOOL_ADMIN
        );
    }

    processData(data: any[]): any[] {
        data.forEach((r: any) => {
            const p = parse(r.text || '');
            r.beschreibung_parse = p;
            r.beschreibung_table = <div>{p}</div>;
        });
        return data;
    }

    render(): JSX.Element {
        const customColumns: any[] = [
            {
                accessor: 'beschreibung_table',
                Header: 'Beschreibung',
                id: 'beschreibung_table',
                type: 'text',
                filterMethod: (filter: any, row: any) => filterMethodFulltext(filter, row._original, 'text')
            }
        ];
        return (
            <WFormsTableWrapper
                entity={IDs.ENT_MEDIEN}
                data={this.state.data}
                module={IDs.MOD_ETOOL_ADMIN}
                actions={this.props.admin ? ['add', 'edit', 'delete'] : []}
                customClass='Custom-ETA'
                customColumns={customColumns}
                formLayout='flowV2'
                hiddenColumns={['text']}
                onSaveDone={() => this.triggerService.fire('admin_reload', IDs.ENT_MEDIEN)}
                showColumnsHelp
                onAfterAction={(action: string) => {
                    if (action === 'saveDone' || action === 'delDone') {
                        this.loadData();
                    }
                }}
                tablePageSize={6}
                defaultSorted={[{ id: 'name', asc: true }]}
                hideExport
            />
       );
    }
}
